(function() {
    'use strict';
    angular
        .module('virtuallibraryApp')
        .factory('Ensamble', Ensamble);

    Ensamble.$inject = ['$resource'];

    function Ensamble ($resource) {
        var resourceUrl =  'api/ensambles/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
